import React from 'react';
import {
  reconciliationAuthBg,
  reconciliationLogo,
  trypilaLogo,
  veldro,
  profiledRiskDark,
} from '../../../../assets/images/images';
import {PrimaryButton} from '../../../../components';
import {Constants, onSignupSuccessHelper} from '../../../../helpers';
import {Link} from 'react-router-dom';
import {ValidateOTP} from '../../../Auths/ValidateOTP';
import {useSignInLogic} from '../../../../hooks/useSignInLogic';

function ReconciloSignIn() {
  const Logic = useSignInLogic();
  const subDomainUser = localStorage.getItem('subdomain');
  const isReconcilo = subDomainUser?.includes('reconcilo');
  const isProfiledRisk = subDomainUser?.includes('profiledrisk');
  const isVeldro = subDomainUser?.includes('veldro');

  const containerStyle = isProfiledRisk
    ? {backgroundColor: '#010080'}
    : {backgroundImage: `url(${reconciliationAuthBg})`};

  return (
    <div
      className={`w-full h-full py-10 bg-cover bg-center bg-no-repeat min-h-screen flex items-center justify-center ${
        isProfiledRisk ? 'font-sans' : ''
      }`}
      style={containerStyle}
    >
      <div className="px-5 lg:px-0 flex flex-col items-center w-full">
        {!isProfiledRisk && (
          <img
            src={
              isReconcilo ? reconciliationLogo : isVeldro ? veldro : trypilaLogo
            }
            alt="App logo"
            className={`${
              isReconcilo
                ? 'w-[192px] h-[37px]'
                : isVeldro
                ? 'w-[200px] h-[120px] object-cover'
                : 'h-8 mt-8'
            } w-auto mb-6`}
          />
        )}

        {Logic.validate2FA ? (
          <div className="bg-white border m-auto border-batchBlue20 py-10 px-8 rounded-2xl w-full md:w-[536px] shadow-reconcilable">
            <ValidateOTP
              onComplete={data =>
                onSignupSuccessHelper(
                  data,
                  Logic.dispatch,
                  Logic.navigate,
                  Logic.location,
                )
              }
              user={Logic.data?.user}
              noLogo
              spinnerClassName="top-0 right-0"
            />
          </div>
        ) : (
          <>
            <div className="bg-white border m-auto border-batchBlue20 py-10 px-8 rounded-2xl w-full md:w-[536px] shadow-reconcilable">
              <div className="">
                {isProfiledRisk && (
                  <img
                    src={profiledRiskDark}
                    alt="App logo"
                    className="mb-6 mx-auto w-[137px] h-[31px]"
                  />
                )}
                <h2 className="text-deepBlue font-semibold text-md mb-[6px]">
                  Welcome Back
                </h2>
                <p className="text-sm text-body">
                  Log in to access and manage your{' '}
                  {isReconcilo
                    ? 'Reconcilo'
                    : isProfiledRisk
                    ? 'Profiledrisk'
                    : isVeldro
                    ? 'Veldro'
                    : 'Trypila'}{' '}
                  account
                </p>
                <form className="mt-8">
                  <label htmlFor="email">
                    Email address
                    <input
                      type="email"
                      name="email"
                      id="op"
                      value={Logic.inputs.email}
                      onChange={Logic.handleInputChange}
                      className="mt-2"
                    />{' '}
                  </label>
                  <label htmlFor="password" className="relative mt-6">
                    Password
                    <input
                      type={Logic.passwordShown ? 'text' : 'password'}
                      id="pw"
                      name="password"
                      className="mt-2"
                      value={Logic.inputs.password}
                      onChange={Logic.handleInputChange}
                    />
                    <span
                      role="button"
                      onClick={Logic.togglePassword}
                      className="absolute text-xs font-medium uppercase cursor-pointer text-grey40 right-3 bottom-4"
                    >
                      {Logic.passwordShown ? 'hide password' : 'show password'}
                    </span>
                  </label>
                  {!isVeldro && (
                    <div className="flex justify-end">
                      <Link
                        to={Constants.PAGES_URL.FORGOT_PASSWORD}
                        className="mt-2 ml-auto text-xs font-medium uppercase text-body"
                      >
                        forgot password?
                      </Link>
                    </div>
                  )}
                </form>
                <PrimaryButton
                  data-testid="sign-in-button"
                  onClick={Logic.handleSubmit}
                  buttonText="Sign In"
                  className="mt-6 h-12 w-full"
                  loading={Logic.sLoading}
                  disabled={Logic.sLoading}
                  loadColor="#2A5392"
                />
              </div>
            </div>

            {isReconcilo && (
              <div className="mt-8 flex items-center justify-center rounded-[30px] px-7 py-4 bg-white">
                <p className="text-sm font-medium text-body">
                  Dont have an account?
                  <Link
                    to={Constants.PAGES_URL.RECONCILIATION_SIGNUP}
                    className="text-brandBlue font-semibold ml-1"
                  >
                    Sign Up
                  </Link>
                </p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default ReconciloSignIn;
